"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.secondsSinceStart = secondsSinceStart;
exports["default"] = useTimer;
exports.withTimer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

function secondsSinceStart(startTime) {
  if (startTime) {
    var startTimeMoment = (0, _moment["default"])(startTime);
    var now = (0, _moment["default"])();
    return now.diff(startTimeMoment, 'seconds');
  }

  return 0;
}

function getInitalTimer(startTime) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return secondsSinceStart(startTime) >= _moment["default"].duration(duration).asSeconds() ? 0 : _moment["default"].duration(duration).asSeconds() - secondsSinceStart(startTime);
}

function useTimer(startTime, duration, active) {
  var startDuration = _moment["default"].duration(duration).asSeconds();

  var _useState = (0, _react.useState)(getInitalTimer(startTime, duration)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  var _useState3 = (0, _react.useState)(active),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isActive = _useState4[0],
      setIsActive = _useState4[1];

  var timerRef = (0, _react.useRef)(timer);
  timerRef.current = timer; // if new message is received with active=false

  (0, _react.useEffect)(function () {
    if (!active) {
      setTimer(0);
      setIsActive(active);
    }
  }, [active, setTimer]);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if (timerRef.current > 0) {
        setTimer(function (prevTimer) {
          return prevTimer - 1;
        });
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, []); // when there was a duration and timer is up, set isActive to false

  (0, _react.useEffect)(function () {
    if (timerRef.current === 0 && duration !== null) {
      setIsActive(false);
    }
  }, [timer, duration, setIsActive]);
  var completed = timer > 0 ? 100 - 100 / startDuration * timer : 0;
  return {
    timer: timer,
    completed: completed,
    setTimer: setTimer,
    isActive: isActive
  };
}

var withTimer = function withTimer(Component) {
  return function (props) {
    var _useTimer = useTimer(props.startTime, props.duration, props.active),
        timer = _useTimer.timer,
        completed = _useTimer.completed,
        setTimer = _useTimer.setTimer,
        isActive = _useTimer.isActive;

    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      timer: timer,
      completed: completed,
      setTimer: setTimer
    }, props, {
      active: isActive
    }));
  };
};

exports.withTimer = withTimer;